import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { RiTeamFill } from "react-icons/ri";
import CustomModalAgents from "./CustomModalAgents";
import { useDispatch, useSelector } from "react-redux";
import { getUsers } from "store/user/userThunk";
import { addTeamLead } from "store/teamLead/teamLeadThunk";
import { getCookie } from "cookies-next";
import { getAssignedAgents } from "store/teamLead/teamLeadThunk";
import DeleteAgentModal from "./DeleteAgentModal";
import AgentDetails from "./AgentDetails";
import { getUnassignedBots } from "store/worker/workerThunk";
import { fetchWorkersAction } from "store/worker/workerThunk";

export default function MainAgent({ color }) {
  const dispatch = useDispatch();
  const { unAssignedBotsData } = useSelector((state) => state.worker) || [];
  const { workers } = useSelector((state) => state.worker);
  const { usersDetails } = useSelector((state) => state.user);
  const { teamLeadData } = useSelector((state) => state.team_lead) || [];
  const [agentDetailsModal, setAgentDetailsModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentTeamLead, setCurrentTeamLead] = useState(null);
  const [agentInfo, setAgentInfo] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [agentToDelete, setAgentToDelete] = useState(null);
  const role = getCookie("user");
  let allAgents =
    role === "admin" ? usersDetails?.all_agents || [] : teamLeadData || [];
  const toggleModal = () => setShowModal(!showModal);

  const handleAddAgent = (newTeamLead) => {
    dispatch(
      addTeamLead({
        newTeamLead,
        onSuccess: () => {
          if (role === "admin") {
            dispatch(getUsers());
          } else {
            dispatch(getAssignedAgents());
          }
        },
      })
    );
  };

  console.log(allAgents, "allAgents");
  allAgents = (function sortAgentsOnStatus(agents) {
    const activeAgents = agents.filter((agent) => agent.isActive === true);
    const inactiveAgents = agents.filter((agent) => agent.isActive === false);
    return [...activeAgents, ...inactiveAgents];
  })(allAgents);

  const agentDetials = (agent) => {
    setAgentInfo(agent);
    dispatch(getUnassignedBots());
    dispatch(fetchWorkersAction()).then(() => {
      setAgentDetailsModal(true);
    });
  };
  const handleDeleteClick = (agent) => {
    setAgentToDelete(agent);
    setShowDeleteModal(true);

    // dispatch(getUsers());
  };

  useEffect(() => {
    if (role === "admin") {
      dispatch(getUsers());
    } else {
      dispatch(getAssignedAgents());
    }
  }, [dispatch]);

  return (
    <>
      <div className="worker_main_container">
        <div className="flex justify-end">
          <button
            className="button_worker"
            onClick={() => {
              setCurrentTeamLead(null);
              toggleModal();
            }}
          >
            Create Agent
          </button>
        </div>
        <div className="card-container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4">
          {allAgents.map((lead, index) => (
            <div
              key={lead.Id || index}
              className={`card h-[320px] w-[250px] shadow-md rounded-lg p-4 flex flex-col justify-between ${
                lead.isActive === false ? "bg-gray-300" : "bg-white"
              }`}
            >
              <div className="card-header flex-grow flex flex-col items-center justify-center">
                <div className="bot-img flex justify-center">
                  <RiTeamFill
                    className={`text-6xl ${
                      lead.isActive ? "text-blue-500" : "text-gray-500"
                    }`}
                    size={50}
                  />
                </div>
                <div className="flex flex-col gap-2 items-center text-center">
                  <p className="font-semibold text-base">
                    {lead.first_name || lead.firstName || "First Name"}{" "}
                    {lead.last_name || lead.lastName || "Last Name"}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">
                    {lead.Email || "No Email"}
                  </p>
                </div>
              </div>
              <div className="flex justify-between gap-4">
                <button
                  onClick={() => agentDetials(lead)}
                  className={`flex items-center justify-center gap-2 w-[50%] rounded-lg text-center text-white px-4 py-2  bg-blue-500 hover:bg-blue-700
                    `}
                  // disabled={lead.isActive === false}
                >
                  Details
                </button>
                <button
                  className={`flex items-center justify-center gap-2 w-[50%] rounded-lg text-center text-white px-4 py-2  bg-red-500 hover:bg-red-700
                    `}
                  onClick={() => handleDeleteClick(lead)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
          {allAgents.length === 0 && (
            <div className="col-span-full text-center text-gray-500 mt-4">
              No data available.
            </div>
          )}
        </div>
      </div>

      {/* Existing modal for creating/editing agents */}
      {showModal && (
        <CustomModalAgents
          toggleModal={toggleModal}
          addTeamLead={handleAddAgent}
          currentTeamLead={currentTeamLead}
        />
      )}

      {/* **New Delete Agent Modal** */}
      {showDeleteModal && (
        <DeleteAgentModal
          toggleModal={() => setShowDeleteModal(false)} // Close modal
          agentName={`${agentToDelete?.first_name || ""} ${
            agentToDelete?.last_name || ""
          }`}
          agentId={agentToDelete.Id}
        />
      )}

      {agentDetailsModal && (
        <AgentDetails
          toggleModal={() => setAgentDetailsModal(false)} // Close modal
          agentData={agentInfo}
          workers={workers}
        />
      )}
    </>
  );
}

MainAgent.defaultProps = {
  color: "light",
};

MainAgent.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
